import { Requisitos } from '../../components/home/Requisitos'
import { Benefits } from '../../components/home/Benefits'
import { Home } from '../../components/backgrounds/Home'

export function RequisitosPage() {
  return (
    <>
    <Home title={'Lo hacemos fácil para ti'} description={'Para aplicar a un crédito en Galilea es muy simple, solo debes cumplir estos 4 requisitos.'} />
    <Requisitos />
    <Benefits />
    </>
  )
}